import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

// Dimensions mirror WorkspaceItem — min-height: 72px, border-radius: medium.
export function WorkspaceItemSkeleton() {
  return (
    <SkeletonLoader
      height={72}
      css={css`
        border-radius: ${theme.borderRadius.medium};
      `}
    />
  );
}
